import { OverlayRef } from '@angular/cdk/overlay';
import { EventEmitter } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface BottomSheet {
  onClose: EventEmitter<any>;
  onClosed: EventEmitter<any>;
}

export class BottomSheetRef<R = any> {
  
  private readonly closed$ = new Subject<R | undefined>();

  constructor(private overlayRef: OverlayRef) {
  }

  dispose(result?: R) {
    this.overlayRef.dispose();
    this.closed$.next(result);
    this.closed$.complete();
  }

  afterDismissed(): Observable<R | undefined> {
    return this.closed$.asObservable();
  }
}
